import React from 'react'
import {
  useSection,
  Section,
  SectionHeader,
  SectionTitleSuffix,
  SectionContent,
} from 'components/Section'
import { observer } from 'mobx-react'
import { TableRow, TableHead, TableHeader, TableBody } from 'components/Table'
import ScopeChangeRequestDetailsViewModel from '../../ScopeChangeRequestDetailsViewModel'
import cx from 'classnames'
import styles from './InventoryItemsSection.sass'
import { ScopeChangePriceBreakDownItemForAdmin } from '../../../../ScopeChangeRequest'
import ServiceTableHeader from '../components/ServiceTableHeader'
import QuantityCell from '../components/QuantityCell'
import ServiceCell from '../components/ServiceCell'
import MoneyCell from '../components/MoneyCell'
import Button from 'components/Button'
import { ScopeChangeRequestBreakdownTable } from '../components/ScopeChangeRequestBreakdownTable'

interface InventoryItemRowProps {
  vm: ScopeChangePriceBreakDownItemForAdmin
  editable: boolean
}

const InventoryItemRow = observer(function InventoryItemRow({
  vm,
  editable,
}: InventoryItemRowProps) {
  return (
    <TableRow>
      <QuantityCell>{vm.quantityDiff}</QuantityCell>
      <ServiceCell detail={vm.bundleAttributionLabel}>{vm.name}</ServiceCell>
      <MoneyCell
        editable={editable}
        model={vm}
        dataTest="scope-change-request-item-price"
        field="priceDiff"
      >
        {vm.priceDiff}
      </MoneyCell>
      <MoneyCell
        editable={editable}
        model={vm}
        dataTest="scope-change-request-item-pro-price"
        field="proPriceDiff"
      >
        {vm.proPriceDiff}
      </MoneyCell>
    </TableRow>
  )
})

interface InventoryItemsSectionProps {
  vm: ScopeChangeRequestDetailsViewModel
}

export default observer(function InventoryItemsSection({
  vm,
}: InventoryItemsSectionProps) {
  const sectionProps = useSection(false)

  return (
    <Section
      {...sectionProps}
      collapsed={!vm.serviceItemsExpanded}
      onToggleCollapse={vm.toggleServiceItemsSection}
    >
      <SectionHeader borderless>
        <div className={styles.headerContainer}>
          <div>
            Service items{' '}
            <SectionTitleSuffix>
              (
              {
                vm.scopeChangeRequestPriceBreakDown
                  .flatInventoryScopeChangeItems.length
              }
              )
            </SectionTitleSuffix>
          </div>
          {(vm.scopeChangeRequest.isPendingFinalization ||
            vm.scopeChangeRequest.isPendingAdminApproval) && (
            <div className={styles.editButton}>
              <Button
                type="text"
                onClick={() =>
                  vm.scopeChangeEditInventoryItemsDialogVM.open(
                    vm.scopeChangeRequest,
                  )
                }
              >
                Edit
              </Button>
            </div>
          )}
        </div>
      </SectionHeader>
      <SectionContent>
        <ScopeChangeRequestBreakdownTable>
          <TableHead className={cx(styles.tableHead)}>
            <TableHeader
              className={cx(styles.quantityTableHeader)}
            ></TableHeader>
            <ServiceTableHeader align="left">Service</ServiceTableHeader>
            <ServiceTableHeader align="right">Client fee</ServiceTableHeader>
            <ServiceTableHeader align="right">Pro cut</ServiceTableHeader>
          </TableHead>
          <TableBody>
            {vm.scopeChangeRequestPriceBreakDown.flatInventoryScopeChangeItems.map(
              (item, i) => (
                <InventoryItemRow editable={false} vm={item} key={i} />
              ),
            )}
          </TableBody>
        </ScopeChangeRequestBreakdownTable>
      </SectionContent>
    </Section>
  )
})
